import React  from "react";
import "./EndOfDay.css"
import EndOfDayBox from "../components/EndOfDayBox";

function EndOfDay() {
    return ( <EndOfDayBox/>)
}

export default EndOfDay;

